import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { MapOxxoTeam2TopicThree } from "./subTopicThree/MapOxxoTeam2TopicThree";
import { CoffeMaker } from "./subTopicThree/CoffeMaker";
import { CoffeeMachineFilling } from "./subTopicThree/CoffeeMachineFilling";
import { CafeteraKobaltoProceso } from "./subTopicThree/CafeteraKobaltoProceso";
import { LimpiezaKobalto } from "./subTopicThree/LimpiezaKobalto";
import { TooltipLimpiezaOne } from "./subTopicThree/TooltipLimpiezaOne";
import { TooltipLimpiezaTwo } from "./subTopicThree/TooltipLimpiezaTwo";
import { ProcesoKrea } from "./subTopicThree/ProcesoKrea";
import { TooltipExtraTop3Act3 } from "./subTopicThree/TooltipsExtra";
import { YeloxProceso } from "./subTopicThree/YeloxProceso";
import { CameraController } from "../../../componets3D/CameraController";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { audiosAssets } from "../../../../assets/audio";

export class SceneTeam2TopicThree extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.stepActivity = 0;
		this.light()
		this.create();
		this.renderAnimations();
		this.observerListeners();
	}

	create() {
		this.mapmenu = new MapOxxoTeam2TopicThree(this.loadingManager);
		this.add(this.mapmenu);
		this.add(this.characterSelected);
		this.coffeMaker = new CoffeMaker(this.camera, this.loadingManager);
		//* act 3,4,5
		this.tooltipsExtra = new TooltipExtraTop3Act3(this.camera, this.loadingManager);
		//* act 3,4,5 --
		//* act3
		this.coffeeMachineFilling = new CoffeeMachineFilling(this.camera, this.loadingManager);
		this.cafeteraKobaltoProceso = new CafeteraKobaltoProceso(this.camera, this.loadingManager);
		this.limpiezaKobalto = new LimpiezaKobalto(this.camera, this.loadingManager);
		this.tooltipLimpiezaOne = new TooltipLimpiezaOne(this.camera, this.loadingManager);
		this.tooltipLimpiezaTwo = new TooltipLimpiezaTwo(this.camera, this.loadingManager);
		//* act3 ---
		//* act4
		this.procesoKrea = new ProcesoKrea(this.camera, this.loadingManager);
		//* act4 ---
		//* act5
		this.yeloxProceso = new YeloxProceso(this.camera, this.loadingManager);
		//* act5 ---
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	SceneOneState() {
		this.stepActivity = 1;
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.coffeMaker.visible = false;
		this.coffeMaker.clearAnimationContenedor()
		this.coffeMaker.clearAnimationsCodo()
		this.add(this.coffeMaker);
		this.characterSelected.onAnimateSaludo();
		this.mouseEvents.disposeInteractions();
		this.coffeMaker.onPosition(1.4497, 0.4521, 1.9486);
		this.mouseEvents.objectsToValue = [
			this.coffeMaker.Contenedor_5,
			this.coffeMaker.Contenedor_4,
			this.coffeMaker.Contenedor_3,
			this.coffeMaker.Contenedor_2,
			this.coffeMaker.Contenedor_1,
		];
		this.mouseListenersEnableMovementActivityOne();
	}

	SceneTwoState() {
		this.stepActivity = 2;
		this.characterSelected.visible = true;
		this.coffeMaker.visible = false;
		this.add(this.coffeMaker);
		this.characterSelected.onAnimateSaludo();

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.coffeMaker
		];
		this.mouseListenersEnableMovementActivityTwo()

		this.coffeMaker.onPosition(1.4497, 0.4521, 1.9486);
	}

	SceneThreeState() {
		this.coffeMaker.onEliminateScene();

		this.stepActivity = 3;
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;

		// this.characterSelected.helpers()

		this.mapmenu.onVisibleCafetera1(false);
		this.mapmenu.onVisibleAnotherPart1();

		this.cafeteraKobaltoProceso.visible = true
		this.cafeteraKobaltoProceso.position.set(-9.6752, -2.9994, -10.21);
		this.cafeteraKobaltoProceso.hiddenChild();
		this.add(this.cafeteraKobaltoProceso);
		this.characterSelected.onAnimateSaludo();
		this.coffeMaker.onPosition(1.4497, 0.4521, 1.9486);

		this.tooltipsExtra.position.set(-10.9985, 0, -8.3519);
		this.tooltipsExtra.onvisibleObjects();
		this.add(this.tooltipsExtra);

		this.coffeeMachineFilling.Kobalto.visible = false

		this.cafeteraKobaltoProceso.Puerta_Mostrador.material.opacity = 1
		this.cafeteraKobaltoProceso.Puerta_Mostrador.visible = true

		this.cafeteraKobaltoProceso.Mostrador.material.opacity = 1
		this.cafeteraKobaltoProceso.Mostrador.visible = true

		this.limpiezaKobalto.visible = false

		this.cafeteraKobaltoProceso.Llave001.position.set(-1.5729, 1.4181, 0.0527);
		this.cafeteraKobaltoProceso.Llave001.rotation.set(0, 0, 0);

		this.cafeteraKobaltoProceso.contenedor03Paso2001.position.set(-1.5941, 0, 0)
		this.cafeteraKobaltoProceso.contenedor03Paso2001.visible = true

		//-- final parte uno
		this.limpiezaKobalto.visible = false
		this.limpiezaKobalto.ResiduosCafe.visible = true
		// -final parte dos
		this.mapmenu.clearAnimation()

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.cafeteraKobaltoProceso.BotonesDeSeleccion,
			this.cafeteraKobaltoProceso.CharolaPortaVaso,
			this.cafeteraKobaltoProceso.ContenedorDeGrano,
			this.cafeteraKobaltoProceso.Dispensador001,
			this.cafeteraKobaltoProceso.Llave003,
			this.cafeteraKobaltoProceso.Pantalla,
			this.cafeteraKobaltoProceso.Llave001,
			this.cafeteraKobaltoProceso.Garrafon001,
			this.cafeteraKobaltoProceso.contenedor03Paso2001,
			this.cafeteraKobaltoProceso.contenedor02Paso1001,
			this.tooltipLimpiezaOne.azucar,
			this.tooltipLimpiezaOne.splenda,
			this.tooltipLimpiezaOne.vaso4,
			this.tooltipLimpiezaOne.vaso12,
			this.tooltipLimpiezaOne.vaso16,
			this.tooltipLimpiezaTwo.agitadores,
			this.tooltipLimpiezaTwo.vasostooltip,
			this.tooltipLimpiezaTwo.tapasextras,
			this.tooltipLimpiezaTwo.tapas,
			this.tooltipLimpiezaTwo.portamangas,
		];
		this.mouseListenersEnableMovementActivityOne();
	}

	SceneFourState() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.mapmenu.onVisibleCafetera1(true);
		this.stepActivity = 4;
		this.mapmenu.onVisibleCafetera_Krea(false);
		this.mapmenu.onVisibleAnotherPart1();

		this.remove(this.cafeteraKobaltoProceso);
		this.remove(this.limpiezaKobalto);
		this.remove(this.tooltipLimpiezaOne);
		this.remove(this.tooltipLimpiezaTwos);

		this.tooltipsExtra.position.set(-10.9985, 0, -8.3519);
		this.tooltipsExtra.onvisibleObjects();
		if (!this.children.includes(this.tooltipsExtra)) {
			this.add(this.tooltipsExtra);
		}

		this.procesoKrea.onvisibleObjects();
		this.procesoKrea.position.set(-14.3447, -1.4589, -8.1449);
		this.procesoKrea.rotation.y = 1.5512;
		this.procesoKrea.visible = true
		this.add(this.procesoKrea);

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.procesoKrea.K_Contenedor_de_grano,
			this.procesoKrea.K_BotonSeleccion,
			this.procesoKrea.K_Dispensador,
			this.procesoKrea.K_Llave,
			this.procesoKrea.K_PantallaDeDatos,
			this.procesoKrea.K_ParillaDeEscurrimiento,
			this.procesoKrea.K_ParillaPortaVaso,
		];
		this.mouseListenersEnableMovementActivityOne();
	}

	SceneFiveState() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.mapmenu.onVisibleCafetera1(true);
		this.mapmenu.onVisibleCafetera_Krea(true);
		this.mapmenu.onVisibleYelox(false);
		this.mapmenu.Cafetera_3.visible = true

		this.mapmenu.Cafe_1.visible = false
		// this.mapmenu.onVisibleAnotherPart1();

		this.stepActivity = 5;

		this.remove(this.procesoKrea);

		this.tooltipsExtra.position.set(-10.9985, 0, -8.3519);
		this.tooltipsExtra.onvisibleObjects();
		if (!this.children.includes(this.tooltipsExtra)) {
			this.add(this.tooltipsExtra);
		}

		this.yeloxProceso.onvisibleObjects();
		this.yeloxProceso.position.set(-14.6051, -1.4822, -5.9531);
		this.yeloxProceso.rotation.y = 1.5512;
		this.yeloxProceso.visible = true
		this.yeloxProceso.Jarra.rotation.set(0, 0, 0)
		this.add(this.yeloxProceso);

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [];
		this.mouseListenersEnableMovementActivityOne();

		ObserverEmitter.on(EVENTS.team2.subtopicTwo.activitySix.moveYelox, (step) => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.3074, -0.2482, -6.0001), 1, new Vector3(-14.57, -0.764, -6.052), () => {
				// -12.3074,-0.2482,-6.0001
				// -14.57,-0.764,-6.052
				this.camera.control.enableRotate = true;
				this.camera.control.enablePan = true;
			});
		});

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-8.8658, -0.1739, 1.7731), 1, new Vector3(-7.758, -0.494, 0.201), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = true;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimateSaludo();
					this.activeAudio()
				});
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.SceneOneState();
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-10.1166, 0.3931, -5.1773), 1, new Vector3(-10.044, -0.307, -7.389), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = true;
					this.camera.control.maxAzimuthAngle = 0.91;
					this.camera.control.minAzimuthAngle = -1.151;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.SceneTwoState();
					this.activeAudio()
				});
				break;
			case 3:
				// this.camera.moveCameraToPoint(new Vector3(-10.1166, 0.3931, -5.1773), 1, new Vector3(-10.044, -0.307, -7.389), () => {
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.SceneThreeState();
					this.activeAudio()
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.SceneFourState();
					this.activeAudio()
				});
				break;
			case 5:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.SceneFiveState();
					this.activeAudio()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-8.8658, -0.1739, 1.7731), 1, new Vector3(-7.758, -0.494, 0.201), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = true;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

				});
				break;
		}
	}

	mouseListenersEnableMovementActivityOne() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				let name = interactions[0].object.name;
				// console.log(name);
				if (name === "contenedor03-Paso2001") {
					name = "contenedor03Paso2001";
				}

				if (name === "contenedor02-Paso1001") {
					name = "contenedor02Paso1001";
				}
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.clickedRayCaster, name);
			}
		});
	}

	mouseListenersEnableMovementActivityTwo() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// let name = interactions[0].object.name;
				// console.log(name);
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.finishClickAct3Part2);
			}
		});
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.moveCoffeTable, (step) => {
			// this.camera.control.maxAzimuthAngle = 0.91;
			// this.camera.control.minAzimuthAngle = -1.151;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-10.1166, 0.3931, -5.1773), 1, new Vector3(-10.044, -0.307, -7.389), () => {
				this.camera.control.enableRotate = false;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.initPosicitionCamare, (step) => {
			// this.camera.control.maxAzimuthAngle = 0.91;
			// this.camera.control.minAzimuthAngle = -1.151;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
				this.camera.control.maxAzimuthAngle = 3.093;
				this.camera.control.minAzimuthAngle = -2.288;
				this.camera.control.enableRotate = false;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.stepUseRayCaster, (step) => {
			if (this.stepActivity === 1) {
				const objectSelect = this.coffeMaker[step];
				if (objectSelect !== undefined) {
					this.coffeMaker.onAnimate(objectSelect, this.stepObject);
				}
			}
			this.stepActive = step;
		});

		//* act 3

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.initAct3Part2, (step) => {
			this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
				this.camera.control.maxAzimuthAngle = 3.093;
				this.camera.control.minAzimuthAngle = -2.288;

				this.SceneTwoState();
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.visibilityCupWhite, () => {
			this.coffeeMachineFilling.position.set(-12.3219, -0.0311, -9.4582);
			this.coffeeMachineFilling.visibilityObjectsKobalto();
			this.add(this.coffeeMachineFilling);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.hiddenCupWhite, () => {
			this.coffeeMachineFilling.hiddemObjects();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.moveMachineCoffe, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.7862, 0.1521, -8.9739), 1, new Vector3(-13.212, -0.681, -10.435), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.775;
				this.camera.control.minAzimuthAngle = 0.081;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true
				this.characterSelected.position.set(-14.1424, -1.4784, -9.4811)
				this.characterSelected.rotation.y = 1.4127
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.moveTableCoffe, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-13.1455, 0.0401, -6.9761), 1, new Vector3(-12.051, -0.4, -8.839), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -0.524;
				this.camera.control.minAzimuthAngle = -0.658;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.moveMachineKey, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.8552, 0.0325, -8.5979), 1, new Vector3(-12.778, -0.477, -10.742), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.447;
				this.camera.control.minAzimuthAngle = -0.612;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.moveMachineContainer, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-14.075, 0.1689, -7.5652), 1, new Vector3(-13.101, -0.449, -9.444), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.8;
				this.camera.control.minAzimuthAngle = -0.683;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = true;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.finishCafeteraKobaltoProceso, () => {
			this.cafeteraKobaltoProceso.position.set(0, 0, 0);
			this.cafeteraKobaltoProceso.visible = false;
			this.limpiezaKobalto.position.set(-12.8139, -1.4781, -9.9414);
			this.limpiezaKobalto.onVisibleObjectSub3Act3();
			this.limpiezaKobalto.visible = true
			this.add(this.limpiezaKobalto);

			this.characterSelected.visible = true
			this.characterSelected.position.set(-11.8881, -1.4329, -9.9703)
			this.characterSelected.rotation.y = -0.6701
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.moveMachineCleanKobalto, () => {
			this.limpiezaKobalto.Rollo.visible = false;
			this.limpiezaKobalto.Rollo.position.set(0, 0, 0);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.6706, -0.7148, -8.4374), 1, new Vector3(-12.732, -1.15, -10.598), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 1.065;
				this.camera.control.minAzimuthAngle = -1.317;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.moveMachineLimpieza, () => {
			this.tooltipLimpiezaOne.position.set(-12.3219, -0.4118, -10.1163);
			this.tooltipLimpiezaOne.onvisibleObjects();
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.3196, -0.4489, -8.5573), 1, new Vector3(-12.088, -0.94, -10.694), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.8;
				this.camera.control.minAzimuthAngle = -0.788;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.tooltipLimpiezaOne.visible = true
				this.add(this.tooltipLimpiezaOne);
				this.mapmenu.onAnimate(this.mapmenu.Vasos);
			});
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.finishStep, () => {
			this.tooltipLimpiezaOne.position.set(0, 0, 0);
			this.tooltipLimpiezaOne.visible = false;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.initStep, () => {
			this.tooltipLimpiezaTwo.position.set(-12.3219, -0.4118, -10.1163);
			this.tooltipLimpiezaTwo.onvisibleObjects();
			this.tooltipLimpiezaTwo.onActiveAgitador();
			this.tooltipLimpiezaTwo.visible = true
			this.add(this.tooltipLimpiezaTwo);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.finishStep, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
				this.camera.control.maxAzimuthAngle = 3.093;
				this.camera.control.minAzimuthAngle = -2.288;
				this.camera.control.enableRotate = false;
				this.characterSelected.visible = true

				this.tooltipLimpiezaTwo.position.set(0, 0, 0);
				this.tooltipLimpiezaTwo.visible = false;
				this.mapmenu.eliminateAnimation(this.mapmenu.Vasos);

				this.characterSelected.position.set(-5.9111, -1.8, -4);
				this.characterSelected.rotation.set(0, 0.9998, 0);
				this.characterSelected.visible = true;
			});
		});

		//* act 3 ---

		//* act 4
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.moveMachineKrea, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.1496, -0.1544, -7.7897), 1, new Vector3(-14.235, -0.844, -7.982), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 2.556;
				this.camera.control.minAzimuthAngle = 0.496;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});
		//* act 4 ----
		//* act 5
		//* act 5 ----
	}

	renderAnimations(delta) { }
}
